import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.png";
import logo_mob from "../img/logo.png";
import MobileMenu from "./MobileMenu";

function Header({ menuOpen, setMenuOpen }) {

    const languages = [
        { value: 'en', label: 'EN' },
        { value: 'ar', label: 'AR' },
        { value: 'bg', label: 'BG' },
        { value: 'de', label: 'DE' },
        { value: 'es', label: 'ES' },
        { value: 'fr', label: 'FR' },
        { value: 'it', label: 'IT' },
        { value: 'pl', label: 'PL' },
        { value: 'zh', label: 'ZH' },
        { value: 'ua', label: 'UA' },
        { value: 'ru', label: 'RU' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    return (
        <div className="fixed w-full bg-[#1D1D1D] z-[900]">
            <div className="max-w-[1220px] justify-between mx-[20px] md:mx-[40px] xl:mx-auto flex items-center py-[10px]">
                <Link to="/"><img src={logo} alt="" className="w-[30px] xl:w-[50px]"/></Link>
                <div className="flex items-center gap-[30px]">
                    <Dropdown
                        options={languages}
                        placeholder="EN"
                        onChange={handleChangeLang}
                        value={languages.find(lang => lang.value === currentLang)}
                        className="z-[999]"
                    />
                    <MobileMenu isOpen={menuOpen} setIsOpen={setMenuOpen}/>
                </div>
                
            </div>
        </div>
    );
}

export default Header;
